export default function PriorityBadge({

    priority = "medium",

    size = "md"

}){

    const config={

        low:{

            label:"Low",

            color:"#15803D",

            background:"#DCFCE7"

        },

        medium:{

            label:"Medium",

            color:"#B45309",

            background:"#FEF3C7"

        },

        high:{

            label:"High",

            color:"#B91C1C",

            background:"#FEE2E2"

        }

    };

    const current=

        config[priority]

        ||

        config.medium;

    return(

        <span

            className={`

                crm-priority-badge

                ${size}

            `}

            style={{

                color:current.color,

                background:current.background

            }}

        >

            <span className="crm-priority-dot"/>

            {current.label}

        </span>

    );

}